import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
} from "react";
import { Select, Tag, DatePicker, Button } from "antd";
import { THEME_PALLETE } from "../../Theme";
import DataHelper from "../../helpers/DataHelper";
import moment from "moment";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const { Option } = Select;
const { RangePicker } = DatePicker;

const ScreenHealthListFilter = forwardRef(
  ({ onFilterChange = () => {}, mode = "media", parentProps }, ref) => {
    const { lang } = useProLanguage();
    const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).analytics;
    const [filters, setFilters] = useState({
      branches: [],
      screens: [],
    });
    const [dates, setDates] = useState(null);
    const [loading, setLoading] = useState(false);
    const [screenDatas, setScreenDatas] = useState([]);
    const [branchesData, setBranchesData] = useState([]);

    const setDateRange = useCallback((dates) => {
      try {
        console.log("setDateRange " + JSON.stringify(dates));
        setFilters((prev) => ({
          ...prev,
          dateRange: dates.map((d) => moment(d)),
        }));
      } catch (e) {
        console.log("setDateRange error " + e);
      }
    }, []);

    // 🧠 Expose functions to parent via ref
    useImperativeHandle(ref, () => ({
      getCurrentFilters: () => filters,
      resetFilters: () => {
        const reset = {
          branches: [],
          screens: [],
        };
        setFilters(reset);
        onFilterChange(reset);
      },
      setDateRange: setDateRange,
    }));

    useEffect(() => {
      if (parentProps && parentProps.selectedBrandData) {
        reloadScreens();
        getFiles();
      }
    }, [parentProps]);

    useEffect(() => {
      console.log(
        "ScreenHealthListFilter useEffect filters changed: " +
          JSON.stringify(filters),
      );
      onFilterChange(filters);
    }, [filters]);

    const getFiles = () => {
      const { selectedBrandData } = parentProps;

      if (!selectedBrandData) {
        return;
      }
      const params = {
        brandid: selectedBrandData.BrandID,
      };

      DataHelper.getBranches(params, parentProps).then((data) => {
        console.log("getBranches " + JSON.stringify(data));
        setBranchesData(data);
      });
    };
    const reloadScreens = () => {
      const { selectedBrandData } = parentProps;
      console.log("reloadScreens");

      setLoading(true);
      DataHelper.getScreens(
        { brandid: selectedBrandData.BrandID },
        parentProps,
      ).then((data) => {
        setScreenDatas(data);
        setLoading(false);
      });
    };

    const disabledDate = (current) => {
      if (!dates) {
        return false;
      }
      const tooLate = dates[0] && current.diff(dates[0], "days") > 7;
      const tooEarly = dates[1] && dates[1].diff(current, "days") > 7;
      return !!tooEarly || !!tooLate;
    };

    const handleFilterChange = (key, value) => {
      console.log("handleFilterChange " + key + " " + value);
      const newFilters = { ...filters, [key]: value };
      setFilters(newFilters);
      onFilterChange(newFilters); // Notify parent
    };

    return (
      <div style={{ width: "100%" }}>
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            gap: 10,
            width: "100%",
            flexWrap: "wrap",
          }}
        >
          {/* Usage Filter */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{ fontWeight: "500", color: "#64748b", marginBottom: 4, fontSize: 12 }}
            >
              {t.filterBranch || "Branch"}
            </label>

            <Select
              // mode="multiple"
              style={{
                minWidth: 150,
                border: "1.5px solid #e2e8f0",
                borderRadius: "8px",
                overflow: "hidden",
              }}
              placeholder={t.filterSelectLocation || "Select Location"}
              onChange={(value) =>
                handleFilterChange("branches", value ? [value] : [])
              }
              allowClear
              loading={loading}
              filterOption={(input, option) => {
                return (option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
            >
              {branchesData.map((branch) => {
                console.log("branch " + JSON.stringify(branch));
                return (
                  <Select.Option key={branch.BranchID} value={branch.BranchID}>
                    {branch.BranchName}
                  </Select.Option>
                );
              })}
            </Select>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label
              style={{ fontWeight: "500", color: "#64748b", marginBottom: 4, fontSize: 12 }}
            >
              {t.filterScreen || "Screen"}
            </label>

            <Select
              // mode="multiple"
              style={{
                minWidth: 150,
                border: "1.5px solid #e2e8f0",
                borderRadius: "8px",
                overflow: "hidden",
              }}
              placeholder={t.filterSelectScreens || "Select screens"}
              onChange={(value) =>
                handleFilterChange("screens", value ? [value] : [])
              }
              allowClear
              optionFilterProp="children"
              loading={loading}
              onSearch={(value) => {
                console.log("search:", value);
              }}
              filterOption={(input, option) => {
                return (option?.children ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
            >
              {screenDatas.map((screen) => {
                console.log("screen " + JSON.stringify(screen));
                return (
                  <Select.Option key={screen.ScreenID} value={screen.ScreenID}>
                    {screen.ScreenName}
                  </Select.Option>
                );
              })}
            </Select>
          </div>
          {/* Expiry Filter */}
          {/* {mode !== "trash" && <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ fontWeight: "500", color: "#666", marginBottom: 4 }}>Expiry</label>
          <Select
            placeholder="Filter by Expiry"
            allowClear
            mode="multiple"
            size="middle"
            style={{ minWidth: 150, border: "1.5px solid #ccc", borderRadius: "5px", overflow: "hidden" }}
            value={filters.expiry}
            onChange={(value) => handleFilterChange("expiry", value)}
          >
            <Option value={1}>{getStatusTag("Active", "expiry")}</Option>
            <Option value={0}>{getStatusTag("Expired", "expiry")}</Option>
          </Select>
        </div>
        } */}
        </div>
      </div>
    );
  },
);

export default ScreenHealthListFilter;
